export default {
      id: "logo_color-usage",
      viewBox: "0 0 38 30",
      url: __webpack_public_path__ + "sprite.svg#logo_color",
      toString: function () {
        return this.url;
      }
    }